import PropTypes from 'prop-types';
import React from 'react';

import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import WorkflowDashboardTemplateTable from './components/WorkflowDashboardTemplateTable';
import {WORKFLOW_TEMPLATE_FULL_SHAPE, WorkflowTemplate} from './WorkflowConstants';

export default function WorkflowDashboardTemplatesScreen({
  workflowTemplates,
}: {
  workflowTemplates?: Array<WorkflowTemplate> | null;
}): JSX.Element {
  return (
    <div className="u-flex-full-height">
      {workflowTemplates ? (
        <WorkflowDashboardTemplateTable workflowTemplates={workflowTemplates} />
      ) : (
        <div className="text-center">
          <HorizontalThrobber />
        </div>
      )}
    </div>
  );
}

WorkflowDashboardTemplatesScreen.propTypes = {
  workflowTemplates: PropTypes.arrayOf(WORKFLOW_TEMPLATE_FULL_SHAPE),
};
